<template>
    <file :file="attachment"></file>
</template>

<script>
    import File from "./File";

    export default {
        name: "Attachment",
        components: {File},
        props: {
            attachment: {type: Object},
        },
    }
</script>
